// extracted by mini-css-extract-plugin
export var cardLayout = "_2q-1";
export var paginationContainer = "_2q-0";